<template>
    <div class="product-family__card">
        <template v-if="type === 'Product'">
            <Product
                :productDisplayName="product?.productDisplayName"
                :translations="translations"
                :productDetailUrl="product?.productDetailUrl"
                :primaryImageUrl="product?.primaryImageUrl"
                :isFinishImageMissing="product?.isFinishImageMissing"
                :portfolio="product?.portfolio"
            ></Product>
        </template>
        <template v-else>
            <Category :displayName="category?.displayName" :imageUrl="category?.imageUrl" :productFilteringUrl="category?.productFilteringUrl" :translations="translations" :isFinishImageMissing="category?.isFinishImageMissing" :portfolio="category?.portfolio"></Category>
        </template>
    </div>
</template>

<script lang="ts">
import Category from 'Vue/components/productFamily/resultTypes/Category.vue';
import Product from 'Vue/components/productFamily/resultTypes/Product.vue';
import { IProductFamilyTranslations } from 'Vue/interfaces/Interfaces';
export default {
    name: 'ProductFamilyResultsCard',
    components: {
        Category,
        Product,
    },
    props: {
        type: {
            type: String,
            default: '',
        },
        product: {
            type: Object,
            default: {} as any,
        },
        category: {
            type: Object,
            default: {} as any,
        },
        translations: {
            type: Object,
            default: {} as IProductFamilyTranslations,
        },
    },
};
</script>
